import { computed } from 'vue'
import { usePage } from "@inertiajs/vue3";

export default function useLang() {
    const lang = computed(() => usePage().props.lang)
    return {
        lang
    }
}
